import { IConfig } from '@cian/config/shared';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { DEFAULT_META } from '../../constants/meta';

import { DEFAULT_PAGINATION } from '../../constants/pagination';
import {
  fetchGetRealtors,
  IGetRealtorsRequest,
  TGetRealtorsResponse,
} from '../../repositories/agent-catalog-search/v2/get-realtors';

export interface IGetRealtorsDeps {
  httpApi: IHttpApi;
  logger: ILogger;
  config: IConfig;
}

export const defaultData = {
  items: [],
  meta: DEFAULT_META,
  ...DEFAULT_PAGINATION,
};

export function getRealtors(deps: IGetRealtorsDeps, parameters: IGetRealtorsRequest) {
  const { httpApi, logger } = deps;

  return fetchGetRealtors({
    httpApi,
    parameters,
  })
    .then((res: TGetRealtorsResponse) => {
      if (res.statusCode === 200) {
        return res.response;
      }

      logger.warning('Bad request agent-catalog-search/v2/get-realtors');

      return defaultData;
    })
    .catch(error => {
      logger.error(error);

      return defaultData;
    });
}
